import React, { useEffect, useState } from "react";
import styles from "./index.module.scss";
import ClassNames from "classnames";
import { useNotification } from "../../context/notification";
import { Method } from "../../config/Config";
import SubjectListWithTarget from "../../components/SubjectListWithTarget";

import { apiRequest } from "../../utils/api";
import { useTranslation } from "react-i18next";
import CoachingDateHistory from "../CoachingDateHistory";

// list items should have the following properties: "value" and "label"
export default function SessionSummary({ id, ...props }) {
  const { t } = useTranslation();
  const { addNotification } = useNotification();
  const [sessionDetails, setSessionDetails] = useState({});
  const [growFormDetails, setGrowFormDetails] = useState({});
  const [subjectList, setSubjectList] = useState([]);
  const [hideProjectTargetKpi, setHideProjectTargetKpi] = useState(false);
  const [hideCurrentMetrics, setHideCurrentMetrics] = useState(false);
  const [hideTargetMetrics, setHideTargetMetrics] = useState(false);

  useEffect(() => {
    // get session details
    apiRequest
      .get(`/api/getSessionDetails?session_id=${id}`)
      .then(response => {
        const data = response.data.data;
        setSessionDetails(data);
        setSubjectList(data.subject);
      })
      .catch(error => {
        console.error(error);
      });

    apiRequest
      .get(`/api/getGrowformDetails?session_id=${id}`)
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data;
          setGrowFormDetails(data.grow_form_static_data);
        } else {
          addNotification(
            t("error.couldNotGetGrowFormDetailsFromSessionId") +
              ` #${id}. (Status code: ${response.status})`,
            "error"
          );
        }
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  const getSessionValue = field => {
    return sessionDetails && sessionDetails["session"]
      ? sessionDetails["session"][field]
      : undefined;
  };

  const getGrowFormValue = field => {
    return growFormDetails ? growFormDetails[field] : undefined;
  };

  useEffect(() => {
    if (
      sessionDetails &&
      sessionDetails.session &&
      sessionDetails.session.session_type_id === 2
    ) {
      setHideProjectTargetKpi(true);
      setHideCurrentMetrics(true);
      setHideTargetMetrics(true);
    } else {
      setHideProjectTargetKpi(false);
      setHideCurrentMetrics(false);
      setHideTargetMetrics(false);
    }
  }, [sessionDetails]);

  const isSpecialSession = sessionDetails?.session?.session_type_id === 3;
  return (
    <div className={ClassNames(styles.detailsContainer, props.className)}>
      <div className={styles.sessionDetailsBlock}>
        <div className={styles.row}>
          <CoachingDateHistory
            sessionData={sessionDetails.session}
            sessionDateHistory={sessionDetails.coaching_date_history}
          />
        </div>
        <div className={styles.row}>
          <div className={styles.rowLeft}>{t("sessionSummary.mode")}</div>
          <div className={styles.rowRight}>
            {Method[getSessionValue("method")]}
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.rowLeft}>
            {t("sessionSummary.typeOfSession")}
          </div>
          <div className={styles.rowRight}>
            {getSessionValue("session_type")}
          </div>
        </div>
      </div>
      <div
        className={ClassNames(styles.sessionGrowFormBlock, styles.borderTop)}
      >
        {isSpecialSession ? (
          <>
            <SubjectListWithTarget
              hideProjectTargetKpi={hideProjectTargetKpi}
              hideCurrentMetrics={hideCurrentMetrics}
              hideTargetMetrics={hideTargetMetrics}
              list={subjectList}
              hasSkillSelect
            />
            {growFormDetails &&
              Object.keys(growFormDetails)
                .filter(key => key.startsWith("question"))
                .map((key, index) => (
                  <div className={styles.row}>
                    <div className={styles.labelNumber}>{index + 1}.</div>
                    <div className={styles.rowLeft}>
                      <div className={styles.labelTitle}>
                        {getGrowFormValue(key)}
                      </div>
                    </div>
                    <div className={styles.rowRight}>
                      <div className={styles.content}>
                        <p>{getGrowFormValue(`answer${index + 1}`)}</p>
                      </div>
                    </div>
                  </div>
                ))}
          </>
        ) : (
          <>
            <div className={styles.row}>
              <div className={styles.rowLeft}>
                <div className={styles.labelTitle}>
                  {t("sessionSummary.goals")}
                </div>
              </div>
              <div className={styles.rowRight}>
                <div className={styles.content}>
                  <p>{getGrowFormValue("goal")}</p>
                </div>
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles.rowLeft}>
                <div className={styles.labelTitle}>
                  {t("sessionSummary.reality")}
                </div>
              </div>
              <div className={styles.rowRight}>
                <SubjectListWithTarget
                  hideProjectTargetKpi={hideProjectTargetKpi}
                  hideCurrentMetrics={hideCurrentMetrics}
                  hideTargetMetrics={hideTargetMetrics}
                  list={subjectList}
                  hasSkillSelect
                />
                <div className={styles.content}>
                  <p>{getGrowFormValue("reality_optional")}</p>
                </div>
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles.rowLeft}>
                <div className={styles.labelTitle}>
                  {t("sessionSummary.options")}
                </div>
              </div>
              <div className={styles.rowRight}>
                <div className={styles.contentContainer}>
                  <div className={styles.content}>
                    <p>{getGrowFormValue("opportunity")}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className={ClassNames(styles.row, styles.noPaddingBottom)}>
              <div className={styles.rowLeft}>
                <div className={styles.labelTitle}>
                  {t("sessionSummary.wayForward")}
                </div>
              </div>
              <div className={styles.rowRight}>
                <div className={styles.contentContainer}>
                  <div className={styles.content}>
                    <p>{getGrowFormValue("way_forward")}</p>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
